// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Billing / Plan page — merchant self-service plan view, upgrade & downgrade.
   Reskinned to the light redesign system: cards/buttons/headers come from the
   shared .rd-* primitives; only page-specific layout lives here, using tokens. */

.billing-page {
  padding: 0;
}

/* Current plan card (card chrome comes from .rd-card) */
.current-plan-card {
  margin-bottom: 24px;
}

.current-plan-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  flex-wrap: wrap;
}

.current-plan-name {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 20px;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: var(--ink);
  text-transform: capitalize;
}

.current-plan-meta-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-top: 22px;
}

.plan-meta-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.plan-meta-item label {
  font-size: 11px;
  font-weight: 600;
  color: var(--ink-muted);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.plan-meta-item span {
  font-size: 15px;
  font-weight: 600;
  color: var(--ink);
}

.grandfathered-note {
  margin-top: 22px;
  padding: 12px 16px;
  background: var(--accent-soft);
  border: 1px solid var(--line);
  border-radius: var(--r-md);
  font-size: 13px;
  color: var(--accent-ink);
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.grandfathered-note svg {
  flex-shrink: 0;
  margin-top: 1px;
}

/* Plan comparison */
.plan-compare-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  margin-bottom: 24px;
}

.plan-card {
  position: relative;
  background: var(--bg-surface);
  border: 1px solid var(--line);
  border-radius: var(--r-lg);
  box-shadow: var(--sh-sm);
  padding: 24px;
  display: flex;
  flex-direction: column;
}

.plan-card.current {
  border-color: var(--accent);
  box-shadow: 0 0 0 1px var(--accent);
}

.plan-card-current-tag {
  position: absolute;
  top: 18px;
  right: 18px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--accent-ink);
}

.plan-card h3 {
  margin: 0 0 8px 0;
  font-size: 16px;
  font-weight: 700;
  color: var(--ink);
}

.plan-price {
  font-size: 28px;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: var(--ink);
  margin-bottom: 18px;
  font-family: var(--iv-sans);
}

.plan-price small {
  font-size: 14px;
  font-weight: 500;
  color: var(--ink-muted);
}

.plan-features {
  list-style: none;
  padding: 0;
  margin: 0 0 22px 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1 1;
}

.plan-features li {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 14px;
  color: var(--ink-secondary);
}

.plan-features li svg {
  flex-shrink: 0;
  color: var(--accent);
  margin-top: 1px;
}

/* Danger buttons layered on top of .rd-btn */
.btn-plan-danger {
  background: var(--bg-surface);
  color: var(--err);
  border-color: var(--err-soft);
}

.btn-plan-danger:hover:not(:disabled) {
  background: var(--err-soft);
}

.btn-confirm-danger {
  background: var(--err);
  color: #fff;
}

.btn-confirm-danger:hover:not(:disabled) {
  filter: brightness(0.94);
}

/* Checkout panel (card chrome comes from .rd-card) */
.checkout-panel {
  margin-bottom: 24px;
}

.checkout-panel h2 {
  margin: 0 0 16px 0;
  font-size: 16px;
  font-weight: 700;
  color: var(--ink);
}

.checkout-line {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid var(--line);
  font-size: 14px;
  color: var(--ink-secondary);
}

.checkout-line.total {
  border-bottom: none;
  font-weight: 700;
  color: var(--ink);
  font-size: 15px;
}

.checkout-pay-meta {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin: 20px 0;
}

.checkout-address-block {
  margin: 20px 0;
}

.checkout-address-block label {
  display: block;
  font-size: 11px;
  color: var(--ink-muted);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 8px;
}

.checkout-address-field {
  display: flex;
  align-items: center;
  gap: 8px;
  background: var(--bg-inset);
  border: 1px solid var(--line);
  border-radius: var(--r-md);
  padding: 10px 12px;
}

.checkout-address-field code {
  flex: 1 1;
  font-size: 13px;
  color: var(--ink);
  word-break: break-all;
}

.checkout-copy-btn {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--r-sm);
  border: 1px solid var(--line-strong);
  background: var(--bg-surface);
  color: var(--ink-secondary);
  cursor: pointer;
}

.checkout-copy-btn:hover {
  color: var(--accent);
  border-color: var(--accent);
}

.checkout-status-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin: 20px 0;
}

.checkout-status-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  border-radius: var(--r-pill);
  font-size: 13px;
  font-weight: 600;
}

.checkout-status-pill.pending {
  background: var(--warn-soft);
  color: var(--warn);
}

.checkout-status-pill.confirmed {
  background: var(--ok-soft);
  color: var(--ok);
}

.checkout-status-pill.expired {
  background: var(--err-soft);
  color: var(--err);
}

.checkout-status-pill .spin {
  animation: billing-spin 1s linear infinite;
}

.checkout-expiry {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: var(--ink-muted);
}

.checkout-expired-note {
  padding: 12px 16px;
  background: var(--err-soft);
  border: 1px solid var(--err-soft);
  border-radius: var(--r-md);
  font-size: 13px;
  color: var(--ink);
  margin-bottom: 20px;
}

.checkout-success {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 12px;
  padding: 16px 0;
}

.checkout-success svg {
  color: var(--ok);
}

.checkout-success h2 {
  margin: 0;
}

.checkout-success p {
  margin: 0;
  font-size: 14px;
  color: var(--ink-secondary);
}

.checkout-success .rd-btn {
  min-width: 160px;
  margin-top: 8px;
}

.checkout-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.checkout-actions .rd-btn {
  flex: 1 1;
  min-width: 140px;
}

/* Billing / receipt history (card chrome comes from .rd-card) */
.billing-history-card {
  margin-bottom: 24px;
}

.billing-history-title {
  margin: 0 0 16px 0;
  font-size: 16px;
  font-weight: 700;
  color: var(--ink);
}

.billing-history-empty {
  margin: 0;
  font-size: 14px;
  color: var(--ink-secondary);
}

.billing-history-scroll {
  overflow-x: auto;
}

.billing-history-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.billing-history-table th {
  text-align: left;
  padding: 10px 12px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--ink-muted);
  border-bottom: 1px solid var(--line);
  white-space: nowrap;
}

.billing-history-table td {
  padding: 12px;
  color: var(--ink-secondary);
  border-bottom: 1px solid var(--line);
  white-space: nowrap;
}

.billing-history-table tbody tr:last-child td {
  border-bottom: none;
}

/* Modal / confirmation */
.billing-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 16px;
}

.billing-modal {
  background: var(--bg-surface);
  border: 1px solid var(--line);
  border-radius: var(--r-lg);
  box-shadow: var(--sh-pop);
  padding: 24px;
  width: 100%;
  max-width: 480px;
  max-height: 90vh;
  overflow-y: auto;
}

.billing-modal h2 {
  margin: 0 0 8px 0;
  font-size: 18px;
  font-weight: 700;
  color: var(--ink);
}

.billing-modal p {
  margin: 0 0 16px 0;
  font-size: 14px;
  color: var(--ink-secondary);
}

.lost-features {
  list-style: none;
  padding: 0;
  margin: 0 0 16px 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.lost-features li {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 14px;
  color: var(--ink-secondary);
}

.lost-features li svg {
  flex-shrink: 0;
  color: var(--err);
  margin-top: 1px;
}

.billing-modal-warning {
  padding: 12px 16px;
  background: var(--bg-inset);
  border-radius: var(--r-md);
  font-size: 13px;
  color: var(--ink);
  margin-bottom: 20px;
}

.billing-modal-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  flex-wrap: wrap;
}

/* Loading */
.billing-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px;
  gap: 16px;
  color: var(--ink-secondary);
}

.billing-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid var(--line);
  border-top-color: var(--accent);
  border-radius: 50%;
  animation: billing-spin 1s linear infinite;
}

@keyframes billing-spin {
  to { transform: rotate(360deg); }
}

/* Tablet+ : two-column plan comparison */
@media (min-width: 768px) {
  .plan-compare-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* Tablet : meta grid to two columns */
@media (max-width: 991px) {
  .current-plan-meta-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* Mobile: single column for everything, bottom-sheet style modal */
@media (max-width: 576px) {
  .current-plan-meta-grid {
    grid-template-columns: 1fr;
  }

  .checkout-pay-meta {
    grid-template-columns: 1fr;
  }

  .billing-modal-overlay {
    align-items: flex-end;
    padding: 0;
  }

  .billing-modal {
    max-width: 100%;
    border-radius: var(--r-lg) var(--r-lg) 0 0;
    max-height: 85vh;
  }

  .checkout-actions .rd-btn {
    flex: 1 1 100%;
  }

  .billing-modal-actions .rd-btn {
    flex: 1 1 100%;
  }

  /* Billing history: table → stacked label/value cards */
  .billing-history-scroll {
    overflow-x: visible;
  }

  .billing-history-table thead {
    display: none;
  }

  .billing-history-table,
  .billing-history-table tbody,
  .billing-history-table tr,
  .billing-history-table td {
    display: block;
    width: 100%;
  }

  .billing-history-table tr {
    border: 1px solid var(--line);
    border-radius: var(--r-md);
    padding: 8px 12px;
    margin-bottom: 12px;
  }

  .billing-history-table td {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    padding: 8px 0;
    border-bottom: 1px solid var(--line);
    white-space: normal;
    text-align: right;
  }

  .billing-history-table tr td:last-child {
    border-bottom: none;
  }

  .billing-history-table td::before {
    content: attr(data-label);
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: var(--ink-muted);
    text-align: left;
  }
}

/* ── Pay-on chain picker (plan card) ──────────────────────────────────────── */
.plan-network { margin: 14px 0 10px; }
.plan-network__label {
  display: block; font-size: 11.5px; font-weight: 600;
  color: var(--t-500, #6c7189); margin-bottom: 6px;
}
.plan-network__opts {
  display: flex; gap: 4px; padding: 3px;
  background: var(--bg-inset, #eff0f8); border-radius: var(--r-md, 10px);
}
.plan-network__opt {
  flex: 1 1; padding: 7px 8px; border: none; background: none; cursor: pointer;
  border-radius: calc(var(--r-md, 10px) - 3px);
  font-family: inherit; font-size: 12px; font-weight: 600;
  color: var(--t-500, #6c7189);
  transition: background 0.15s, color 0.15s;
}
.plan-network__opt:hover:not(:disabled) { color: var(--ink, #0e1124); }
.plan-network__opt.is-active {
  background: var(--surface, #fff); color: var(--ink, #0e1124);
  box-shadow: var(--sh-sm, 0 1px 2px rgba(16, 18, 40, 0.06));
}
.plan-network__opt:disabled { opacity: 0.55; cursor: default; }

.plan-credit {
  margin: 0 0 10px; padding: 8px 10px;
  background: var(--ok-soft, #e6f8f1); color: var(--ok-ink, #0a8f64);
  border-radius: var(--r-md, 10px);
  font-size: 12px; font-weight: 600; line-height: 1.4;
}

/* Premium: when it ends, above the renew controls. Neutral, not "credit" green. */
.plan-active-until {
  margin-top: 16px;
  background: var(--bg-inset, #f7f8fc); color: var(--t-600, #4a4f66);
}
.plan-cancel-btn { margin-top: 8px; }

/* Test mode: why the upgrade button is disabled. */
.plan-test-note {
  display: flex; align-items: flex-start; gap: 6px;
  margin: 0 0 10px; padding: 8px 10px;
  background: var(--warn-soft, #fdf3e1); color: var(--warn-ink, #b9760a);
  border-radius: var(--r-md, 10px);
  font-size: 12px; font-weight: 600; line-height: 1.4;
}
.plan-test-note svg { flex: none; margin-top: 1px; }

/* A part-paid row in the history has to explain itself, or it reads as
   "we took your money and gave you nothing". */
.billing-part-paid {
  display: block; margin-top: 2px;
  font-size: 11px; font-weight: 600; color: var(--warn-ink, #b9760a);
}

/* ═══════════════════════════════════════════════════════════════════════════
   Billing, 2026 layout: gradient plan hero, KPI row, history beside the offer.
   ═══════════════════════════════════════════════════════════════════════════ */

/* ── Hero ─────────────────────────────────────────────────────────────────── */
.bill-hero {
  padding: 24px 28px; margin-bottom: var(--space-5, 20px);
  border-radius: var(--r-xl, 20px);
  /* The mockup's violet, deepening across the band. Measured against white:
     6.3:1 at the start, 9.3:1 at the end, so every stop clears the 4.5:1 body
     minimum -- including the 68%-alpha sub-labels, which flatten to 4.7:1. */
  background: var(--grad-balance);
  color: #fff;
  position: relative; overflow: hidden;
}
/* The soft bloom in the mockup's top-right. Decorative only. */
.bill-hero::after {
  content: ''; position: absolute; right: -60px; top: -70px;
  width: 260px; height: 260px; border-radius: 50%;
  background: rgba(255, 255, 255, 0.07); pointer-events: none;
}

/* Band 1: who you are and the one action that changes it. */
.bill-hero__top {
  position: relative; z-index: 1;
  display: flex; align-items: flex-start; justify-content: space-between;
  gap: 24px; flex-wrap: wrap;
}

.bill-hero__plan { display: flex; align-items: flex-start; gap: 14px; min-width: 240px; }
.bill-hero__crest {
  flex: none; width: 46px; height: 46px; display: grid; place-items: center;
  border-radius: 14px; background: rgba(255, 255, 255, 0.16);
}
.bill-hero__eyebrow {
  display: block; font-size: 12px; font-weight: 600;
  color: rgba(255, 255, 255, 0.78); margin-bottom: 2px;
}
.bill-hero__name { display: flex; align-items: center; gap: 10px; }
.bill-hero__name h2 {
  margin: 0; font-size: 26px; line-height: 1.1; text-transform: capitalize; color: #fff;
}
.bill-hero__status {
  font-size: 11.5px; font-weight: 700; text-transform: capitalize;
  padding: 3px 10px; border-radius: 999px;
  background: rgba(255, 255, 255, 0.22); color: #fff;
}
.bill-hero__blurb {
  margin: 6px 0 0; font-size: 13px; line-height: 1.45;
  color: rgba(255, 255, 255, 0.8); max-width: 46ch;
}

.bill-hero__cta {
  flex: none; display: inline-flex; align-items: center; gap: 8px;
  padding: 11px 20px; border: none; border-radius: 999px; cursor: pointer;
  background: #fff; color: #3e31ae;
  font-family: inherit; font-size: 13.5px; font-weight: 700;
  transition: transform 0.14s ease, box-shadow 0.14s ease;
}
.bill-hero__cta:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(16, 18, 40, 0.22);
}
.bill-hero__cta:disabled { opacity: 0.65; cursor: default; }

/* Band 2: the figures, on an even grid.
   A grid rather than a flex row so the four columns are the same width and the
   labels line up, instead of each one taking whatever space was left. */
.bill-hero__stats {
  position: relative; z-index: 1;
  display: grid; grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 1px; margin-top: 22px; padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.16);
}
.bill-hero__stat { padding: 0 18px; min-width: 0; }
.bill-hero__stat + .bill-hero__stat { box-shadow: inset 1px 0 0 rgba(255, 255, 255, 0.14); }
.bill-hero__stat:first-child { padding-left: 0; }
.bill-hero__stat:last-child { padding-right: 0; }

.bill-hero__stat-icon {
  width: 28px; height: 28px; display: grid; place-items: center;
  border-radius: 50%; border: 1px solid rgba(255, 255, 255, 0.3);
  margin-bottom: 9px;
}
.bill-hero__stat-label {
  display: block; font-size: 12px; font-weight: 600;
  color: rgba(255, 255, 255, 0.82); margin-bottom: 3px;
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.bill-hero__stat strong {
  display: block; font-size: 22px; font-weight: 700; line-height: 1.15;
  font-variant-numeric: tabular-nums; color: #fff;
}
.bill-hero__stat-sub {
  display: block; margin-top: 3px;
  font-size: 11.5px; color: rgba(255, 255, 255, 0.68);
}

/* ── History + offer ──────────────────────────────────────────────────────── */
/* Both columns share the row height, so the two cards end level. With
   align-items: start the history card sized to its own rows -- four of them in
   a three-month window -- and finished 150px above the offer card beside it.
   Stretching is safe because the slack has somewhere to go: the table area
   grows and the pager is pinned to the bottom. */
.bill-grid {
  display: grid; grid-template-columns: minmax(0, 1fr) 360px;
  gap: var(--space-5, 20px); align-items: stretch;
}

.bill-history { overflow: hidden; display: flex; flex-direction: column; }
/* Takes the leftover height rather than letting it pool under the card. */
.bill-history__scroll { flex: 1 1; }
.bill-history .pager {
  margin-top: auto;
  padding: 12px 20px;
  border-top: 1px solid var(--line, #eaebf3);
}

.bill-side { display: flex; flex-direction: column; }
/* .bill-side > * { flex: 1; } */
.bill-history__head {
  display: flex; align-items: flex-start; justify-content: space-between;
  gap: 16px; flex-wrap: wrap;
  padding: 18px 20px; border-bottom: 1px solid var(--line, #eaebf3);
}
.bill-history__head h2 { margin: 0; font-size: 17px; }
.bill-history__head p { margin: 3px 0 0; font-size: 12.5px; color: var(--t-500, #6c7189); }

.bill-range {
  display: inline-flex; align-items: center; gap: 7px;
  padding: 7px 11px; border: 1px solid var(--line, #eaebf3);
  border-radius: var(--r-md, 10px); background: var(--surface, #fff);
  color: var(--t-500, #6c7189);
}
.bill-range select {
  border: none; background: none; outline: none; cursor: pointer;
  font-family: inherit; font-size: 12.5px; font-weight: 600;
  color: var(--ink, #0e1124);
}

.bill-history__scroll { overflow-x: auto; flex: 1 1; }
.bill-table { width: 100%; border-collapse: collapse; }
.bill-table thead th {
  text-align: left; padding: 11px 20px;
  font-size: 11px; font-weight: 700; letter-spacing: 0.4px; text-transform: uppercase;
  color: var(--t-500, #6c7189); background: var(--bg-inset, #f7f8fc);
  border-bottom: 1px solid var(--line, #eaebf3);
  white-space: nowrap;
}
.bill-table tbody td {
  padding: 13px 20px; font-size: 13px; vertical-align: middle;
  color: var(--ink, #0e1124);
  border-bottom: 1px solid var(--line, #eaebf3);
}
.bill-table tbody tr:last-child td { border-bottom: none; }
.bill-table tbody tr { transition: background 0.14s ease; }
.bill-table tbody tr:hover { background: rgba(109, 93, 246, 0.04); }
.bill-num { text-align: right; }
.bill-plan { text-transform: capitalize; }

.bill-token { display: inline-flex; align-items: center; gap: 8px; font-weight: 600; white-space: nowrap; }

.bill-history__empty {
  flex: 1 1; display: flex; flex-direction: column;
  align-items: center; justify-content: center;
  text-align: center; padding: 46px 20px;
}
.bill-history__empty-icon {
  display: inline-grid; place-items: center; width: 48px; height: 48px;
  border-radius: 14px; margin-bottom: 12px;
  background: var(--brand-100, #ece9ff); color: var(--brand-700, #5847d6);
}
.bill-history__empty h3 { margin: 0 0 5px; font-size: 15px; }
.bill-history__empty p { margin: 0; font-size: 13px; color: var(--t-500, #6c7189); }

/* ── Offer card (right rail) ──────────────────────────────────────────────── */
/* The card fills its column, so the slack goes between the feature list and
   the action rather than below everything -- the same reason the pager is
   pinned in the card beside it. */
.bill-offer { display: flex; flex-direction: column; }
.bill-offer__features { margin-bottom: auto !important; }
.bill-offer .plan-network { margin-top: 18px; }

.bill-offer h3 { margin: 0 0 4px; font-size: 16px; }
.bill-offer__blurb { margin: 0; font-size: 13px; color: var(--t-500, #6c7189); line-height: 1.5; }
.bill-offer__price {
  font-size: 30px; font-weight: 700; margin: 2px 0 14px;
  color: var(--ink, #0e1124); font-variant-numeric: tabular-nums;
}
.bill-offer__price small { font-size: 13px; font-weight: 600; color: var(--t-500, #6c7189); }
.bill-offer__features { list-style: none; margin: 0 0 16px; padding: 0; display: grid; gap: 8px; }
.bill-offer__features li {
  display: flex; align-items: flex-start; gap: 8px;
  font-size: 12.5px; line-height: 1.4; color: var(--t-600, #4a4f66);
}
.bill-offer__features svg { flex: none; margin-top: 1px; color: var(--ok, #0fb981); }

/* ── Narrow ───────────────────────────────────────────────────────────────── */
@media (max-width: 1180px) {
  .bill-grid { grid-template-columns: minmax(0, 1fr); }
  .bill-side { max-width: 520px; }
  /* Stacked, there is no neighbour to match, so nothing should be stretched. */
  .bill-side > * { flex: none; }
}
@media (max-width: 1040px) {
  .bill-hero__stats { grid-template-columns: repeat(2, minmax(0, 1fr)); row-gap: 20px; }
  .bill-hero__stat:nth-child(odd) { padding-left: 0; }
  .bill-hero__stat:nth-child(3) { box-shadow: none; }
}
@media (max-width: 900px) {
  .bill-hero { gap: 20px; padding: 22px; }
  .bill-hero__cta { width: 100%; justify-content: center; }
}
@media (max-width: 560px) {
  .bill-hero__stats { grid-template-columns: minmax(0, 1fr); row-gap: 18px; }
  .bill-hero__stat { padding: 0; box-shadow: none !important; }
  .bill-hero__cta { width: 100%; justify-content: center; }
  .bill-table thead th, .bill-table tbody td { padding-left: 14px; padding-right: 14px; }
}

@media (prefers-reduced-motion: reduce) {
  .bill-hero__cta { transition: none; }
  .bill-hero__cta:hover:not(:disabled) { transform: none; }
}

/* A charge that never confirmed earned no receipt. Saying so beats a dash. */
.bill-no-receipt {
  font-family: var(--font-sans, inherit);
  font-size: 12px; color: var(--t-400, #9aa0b6); font-style: italic;
}

/* Placeholder while the real price is in flight. Dimmed so it reads as
   "not yet" rather than as a figure. */
.bill-offer__price-wait { color: var(--t-400, #9aa0b6); }
`, "",{"version":3,"sources":["webpack://./src/pages/Billing.css"],"names":[],"mappings":"AAAA;;iFAEiF;;AAEjF;EACE,UAAU;AACZ;;AAEA,wDAAwD;AACxD;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;EAC9B,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;EACf,wBAAwB;EACxB,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,6BAA6B;EAC7B,0BAA0B;EAC1B,wBAAwB;EACxB,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;AACjB;;AAEA,6CAA6C;AAC7C;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,qDAAqD;AACrD;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,oCAAoC;EACpC,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,oCAAoC;EACpC,6BAA6B;EAC7B,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,iCAAiC;EACjC,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA,gEAAgE;AAChE;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;EACzB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,+BAA+B;EAC/B,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,yCAAyC;AACzC;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA,sCAAsC;AACtC;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA,mEAAmE;AACnE;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,0CAA0C;IAC1C,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA,uDAAuD;EACvD;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;;;;IAIE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,6BAA6B;IAC7B,0BAA0B;IAC1B,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,cAAc;IACd,oCAAoC;IACpC,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;EAClB;AACF;;AAEA,gFAAgF;AAChF,gBAAgB,mBAAmB,EAAE;AACrC;EACE,cAAc,EAAE,iBAAiB,EAAE,gBAAgB;EACnD,4BAA4B,EAAE,kBAAkB;AAClD;AACA;EACE,aAAa,EAAE,QAAQ,EAAE,YAAY;EACrC,oCAAoC,EAAE,gCAAgC;AACxE;AACA;EACE,SAAO,EAAE,gBAAgB,EAAE,YAAY,EAAE,gBAAgB,EAAE,eAAe;EAC1E,4CAA4C;EAC5C,oBAAoB,EAAE,eAAe,EAAE,gBAAgB;EACvD,4BAA4B;EAC5B,yCAAyC;AAC3C;AACA,0CAA0C,0BAA0B,EAAE;AACtE;EACE,gCAAgC,EAAE,0BAA0B;EAC5D,0DAA0D;AAC5D;AACA,8BAA8B,aAAa,EAAE,eAAe,EAAE;;AAE9D;EACE,gBAAgB,EAAE,iBAAiB;EACnC,mCAAmC,EAAE,6BAA6B;EAClE,gCAAgC;EAChC,eAAe,EAAE,gBAAgB,EAAE,gBAAgB;AACrD;;AAEA,kFAAkF;AAClF;EACE,gBAAgB;EAChB,oCAAoC,EAAE,4BAA4B;AACpE;AACA,mBAAmB,eAAe,EAAE;;AAEpC,mDAAmD;AACnD;EACE,aAAa,EAAE,uBAAuB,EAAE,QAAQ;EAChD,gBAAgB,EAAE,iBAAiB;EACnC,qCAAqC,EAAE,+BAA+B;EACtE,gCAAgC;EAChC,eAAe,EAAE,gBAAgB,EAAE,gBAAgB;AACrD;AACA,sBAAsB,UAAU,EAAE,eAAe,EAAE;;AAEnD;+CAC+C;AAC/C;EACE,cAAc,EAAE,eAAe;EAC/B,eAAe,EAAE,gBAAgB,EAAE,+BAA+B;AACpE;;AAEA;;gFAEgF;;AAEhF,gFAAgF;AAChF;EACE,kBAAkB,EAAE,mCAAmC;EACvD,gCAAgC;EAChC;;6EAE2E;EAC3E,+BAA+B;EAC/B,WAAW;EACX,kBAAkB,EAAE,gBAAgB;AACtC;AACA,+DAA+D;AAC/D;EACE,WAAW,EAAE,kBAAkB,EAAE,YAAY,EAAE,UAAU;EACzD,YAAY,EAAE,aAAa,EAAE,kBAAkB;EAC/C,qCAAqC,EAAE,oBAAoB;AAC7D;;AAEA,4DAA4D;AAC5D;EACE,kBAAkB,EAAE,UAAU;EAC9B,aAAa,EAAE,uBAAuB,EAAE,8BAA8B;EACtE,SAAS,EAAE,eAAe;AAC5B;;AAEA,mBAAmB,aAAa,EAAE,uBAAuB,EAAE,SAAS,EAAE,gBAAgB,EAAE;AACxF;EACE,UAAU,EAAE,WAAW,EAAE,YAAY,EAAE,aAAa,EAAE,mBAAmB;EACzE,mBAAmB,EAAE,qCAAqC;AAC5D;AACA;EACE,cAAc,EAAE,eAAe,EAAE,gBAAgB;EACjD,gCAAgC,EAAE,kBAAkB;AACtD;AACA,mBAAmB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AAClE;EACE,SAAS,EAAE,eAAe,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,WAAW;AACvF;AACA;EACE,iBAAiB,EAAE,gBAAgB,EAAE,0BAA0B;EAC/D,iBAAiB,EAAE,oBAAoB;EACvC,qCAAqC,EAAE,WAAW;AACpD;AACA;EACE,eAAe,EAAE,eAAe,EAAE,iBAAiB;EACnD,+BAA+B,EAAE,eAAe;AAClD;;AAEA;EACE,UAAU,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EAC/D,kBAAkB,EAAE,YAAY,EAAE,oBAAoB,EAAE,eAAe;EACvE,gBAAgB,EAAE,cAAc;EAChC,oBAAoB,EAAE,iBAAiB,EAAE,gBAAgB;EACzD,uDAAuD;AACzD;AACA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;AACA,2BAA2B,aAAa,EAAE,eAAe,EAAE;;AAE3D;;wEAEwE;AACxE;EACE,kBAAkB,EAAE,UAAU;EAC9B,aAAa,EAAE,gDAAgD;EAC/D,QAAQ,EAAE,gBAAgB,EAAE,iBAAiB;EAC7C,+CAA+C;AACjD;AACA,mBAAmB,eAAe,EAAE,YAAY,EAAE;AAClD,sCAAsC,mDAAmD,EAAE;AAC3F,+BAA+B,eAAe,EAAE;AAChD,8BAA8B,gBAAgB,EAAE;;AAEhD;EACE,WAAW,EAAE,YAAY,EAAE,aAAa,EAAE,mBAAmB;EAC7D,kBAAkB,EAAE,0CAA0C;EAC9D,kBAAkB;AACpB;AACA;EACE,cAAc,EAAE,eAAe,EAAE,gBAAgB;EACjD,gCAAgC,EAAE,kBAAkB;EACpD,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB;AAChE;AACA;EACE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE,iBAAiB;EACpE,kCAAkC,EAAE,WAAW;AACjD;AACA;EACE,cAAc,EAAE,eAAe;EAC/B,iBAAiB,EAAE,gCAAgC;AACrD;;AAEA,gFAAgF;AAChF;;;;iDAIiD;AACjD;EACE,aAAa,EAAE,2CAA2C;EAC1D,yBAAyB,EAAE,oBAAoB;AACjD;;AAEA,gBAAgB,gBAAgB,EAAE,aAAa,EAAE,sBAAsB,EAAE;AACzE,0EAA0E;AAC1E,wBAAwB,SAAO,EAAE;AACjC;EACE,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA,aAAa,aAAa,EAAE,sBAAsB,EAAE;AACpD,gCAAgC;AAChC;EACE,aAAa,EAAE,uBAAuB,EAAE,8BAA8B;EACtE,SAAS,EAAE,eAAe;EAC1B,kBAAkB,EAAE,6CAA6C;AACnE;AACA,yBAAyB,SAAS,EAAE,eAAe,EAAE;AACrD,wBAAwB,eAAe,EAAE,iBAAiB,EAAE,4BAA4B,EAAE;;AAE1F;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACnD,iBAAiB,EAAE,sCAAsC;EACzD,gCAAgC,EAAE,gCAAgC;EAClE,4BAA4B;AAC9B;AACA;EACE,YAAY,EAAE,gBAAgB,EAAE,aAAa,EAAE,eAAe;EAC9D,oBAAoB,EAAE,iBAAiB,EAAE,gBAAgB;EACzD,0BAA0B;AAC5B;;AAEA,wBAAwB,gBAAgB,EAAE,SAAO,EAAE;AACnD,cAAc,WAAW,EAAE,yBAAyB,EAAE;AACtD;EACE,gBAAgB,EAAE,kBAAkB;EACpC,eAAe,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,yBAAyB;EACnF,4BAA4B,EAAE,oCAAoC;EAClE,6CAA6C;EAC7C,mBAAmB;AACrB;AACA;EACE,kBAAkB,EAAE,eAAe,EAAE,sBAAsB;EAC3D,0BAA0B;EAC1B,6CAA6C;AAC/C;AACA,qCAAqC,mBAAmB,EAAE;AAC1D,uBAAuB,iCAAiC,EAAE;AAC1D,6BAA6B,oCAAoC,EAAE;AACnE,YAAY,iBAAiB,EAAE;AAC/B,aAAa,0BAA0B,EAAE;;AAEzC,cAAc,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;;AAE1G;EACE,SAAO,EAAE,aAAa,EAAE,sBAAsB;EAC9C,mBAAmB,EAAE,uBAAuB;EAC5C,kBAAkB,EAAE,kBAAkB;AACxC;AACA;EACE,oBAAoB,EAAE,mBAAmB,EAAE,WAAW,EAAE,YAAY;EACpE,mBAAmB,EAAE,mBAAmB;EACxC,qCAAqC,EAAE,gCAAgC;AACzE;AACA,0BAA0B,eAAe,EAAE,eAAe,EAAE;AAC5D,yBAAyB,SAAS,EAAE,eAAe,EAAE,4BAA4B,EAAE;;AAEnF,gFAAgF;AAChF;;kCAEkC;AAClC,cAAc,aAAa,EAAE,sBAAsB,EAAE;AACrD,wBAAwB,8BAA8B,EAAE;AACxD,4BAA4B,gBAAgB,EAAE;;AAE9C,iBAAiB,eAAe,EAAE,eAAe,EAAE;AACnD,qBAAqB,SAAS,EAAE,eAAe,EAAE,4BAA4B,EAAE,gBAAgB,EAAE;AACjG;EACE,eAAe,EAAE,gBAAgB,EAAE,kBAAkB;EACrD,0BAA0B,EAAE,kCAAkC;AAChE;AACA,2BAA2B,eAAe,EAAE,gBAAgB,EAAE,4BAA4B,EAAE;AAC5F,wBAAwB,gBAAgB,EAAE,gBAAgB,EAAE,UAAU,EAAE,aAAa,EAAE,QAAQ,EAAE;AACjG;EACE,aAAa,EAAE,uBAAuB,EAAE,QAAQ;EAChD,iBAAiB,EAAE,gBAAgB,EAAE,4BAA4B;AACnE;AACA,4BAA4B,UAAU,EAAE,eAAe,EAAE,yBAAyB,EAAE;;AAEpF,gFAAgF;AAChF;EACE,aAAa,qCAAqC,EAAE;EACpD,aAAa,gBAAgB,EAAE;EAC/B,6EAA6E;EAC7E,iBAAiB,UAAU,EAAE;AAC/B;AACA;EACE,oBAAoB,gDAAgD,EAAE,aAAa,EAAE;EACrF,kCAAkC,eAAe,EAAE;EACnD,gCAAgC,gBAAgB,EAAE;AACpD;AACA;EACE,aAAa,SAAS,EAAE,aAAa,EAAE;EACvC,kBAAkB,WAAW,EAAE,uBAAuB,EAAE;AAC1D;AACA;EACE,oBAAoB,qCAAqC,EAAE,aAAa,EAAE;EAC1E,mBAAmB,UAAU,EAAE,2BAA2B,EAAE;EAC5D,kBAAkB,WAAW,EAAE,uBAAuB,EAAE;EACxD,6CAA6C,kBAAkB,EAAE,mBAAmB,EAAE;AACxF;;AAEA;EACE,kBAAkB,gBAAgB,EAAE;EACpC,uCAAuC,eAAe,EAAE;AAC1D;;AAEA,6EAA6E;AAC7E;EACE,sCAAsC;EACtC,eAAe,EAAE,4BAA4B,EAAE,kBAAkB;AACnE;;AAEA;uCACuC;AACvC,0BAA0B,4BAA4B,EAAE","sourcesContent":["/* Billing / Plan page — merchant self-service plan view, upgrade & downgrade.\n   Reskinned to the light redesign system: cards/buttons/headers come from the\n   shared .rd-* primitives; only page-specific layout lives here, using tokens. */\n\n.billing-page {\n  padding: 0;\n}\n\n/* Current plan card (card chrome comes from .rd-card) */\n.current-plan-card {\n  margin-bottom: 24px;\n}\n\n.current-plan-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.current-plan-name {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 20px;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  color: var(--ink);\n  text-transform: capitalize;\n}\n\n.current-plan-meta-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 20px;\n  margin-top: 22px;\n}\n\n.plan-meta-item {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.plan-meta-item label {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--ink-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.plan-meta-item span {\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--ink);\n}\n\n.grandfathered-note {\n  margin-top: 22px;\n  padding: 12px 16px;\n  background: var(--accent-soft);\n  border: 1px solid var(--line);\n  border-radius: var(--r-md);\n  font-size: 13px;\n  color: var(--accent-ink);\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n}\n\n.grandfathered-note svg {\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n\n/* Plan comparison */\n.plan-compare-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 20px;\n  margin-bottom: 24px;\n}\n\n.plan-card {\n  position: relative;\n  background: var(--bg-surface);\n  border: 1px solid var(--line);\n  border-radius: var(--r-lg);\n  box-shadow: var(--sh-sm);\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n}\n\n.plan-card.current {\n  border-color: var(--accent);\n  box-shadow: 0 0 0 1px var(--accent);\n}\n\n.plan-card-current-tag {\n  position: absolute;\n  top: 18px;\n  right: 18px;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--accent-ink);\n}\n\n.plan-card h3 {\n  margin: 0 0 8px 0;\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--ink);\n}\n\n.plan-price {\n  font-size: 28px;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  color: var(--ink);\n  margin-bottom: 18px;\n  font-family: var(--iv-sans);\n}\n\n.plan-price small {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--ink-muted);\n}\n\n.plan-features {\n  list-style: none;\n  padding: 0;\n  margin: 0 0 22px 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  flex: 1;\n}\n\n.plan-features li {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  font-size: 14px;\n  color: var(--ink-secondary);\n}\n\n.plan-features li svg {\n  flex-shrink: 0;\n  color: var(--accent);\n  margin-top: 1px;\n}\n\n/* Danger buttons layered on top of .rd-btn */\n.btn-plan-danger {\n  background: var(--bg-surface);\n  color: var(--err);\n  border-color: var(--err-soft);\n}\n\n.btn-plan-danger:hover:not(:disabled) {\n  background: var(--err-soft);\n}\n\n.btn-confirm-danger {\n  background: var(--err);\n  color: #fff;\n}\n\n.btn-confirm-danger:hover:not(:disabled) {\n  filter: brightness(0.94);\n}\n\n/* Checkout panel (card chrome comes from .rd-card) */\n.checkout-panel {\n  margin-bottom: 24px;\n}\n\n.checkout-panel h2 {\n  margin: 0 0 16px 0;\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--ink);\n}\n\n.checkout-line {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 0;\n  border-bottom: 1px solid var(--line);\n  font-size: 14px;\n  color: var(--ink-secondary);\n}\n\n.checkout-line.total {\n  border-bottom: none;\n  font-weight: 700;\n  color: var(--ink);\n  font-size: 15px;\n}\n\n.checkout-pay-meta {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 20px;\n  margin: 20px 0;\n}\n\n.checkout-address-block {\n  margin: 20px 0;\n}\n\n.checkout-address-block label {\n  display: block;\n  font-size: 11px;\n  color: var(--ink-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-bottom: 8px;\n}\n\n.checkout-address-field {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: var(--bg-inset);\n  border: 1px solid var(--line);\n  border-radius: var(--r-md);\n  padding: 10px 12px;\n}\n\n.checkout-address-field code {\n  flex: 1;\n  font-size: 13px;\n  color: var(--ink);\n  word-break: break-all;\n}\n\n.checkout-copy-btn {\n  flex-shrink: 0;\n  width: 44px;\n  height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--r-sm);\n  border: 1px solid var(--line-strong);\n  background: var(--bg-surface);\n  color: var(--ink-secondary);\n  cursor: pointer;\n}\n\n.checkout-copy-btn:hover {\n  color: var(--accent);\n  border-color: var(--accent);\n}\n\n.checkout-status-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin: 20px 0;\n}\n\n.checkout-status-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 5px 12px;\n  border-radius: var(--r-pill);\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.checkout-status-pill.pending {\n  background: var(--warn-soft);\n  color: var(--warn);\n}\n\n.checkout-status-pill.confirmed {\n  background: var(--ok-soft);\n  color: var(--ok);\n}\n\n.checkout-status-pill.expired {\n  background: var(--err-soft);\n  color: var(--err);\n}\n\n.checkout-status-pill .spin {\n  animation: billing-spin 1s linear infinite;\n}\n\n.checkout-expiry {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  color: var(--ink-muted);\n}\n\n.checkout-expired-note {\n  padding: 12px 16px;\n  background: var(--err-soft);\n  border: 1px solid var(--err-soft);\n  border-radius: var(--r-md);\n  font-size: 13px;\n  color: var(--ink);\n  margin-bottom: 20px;\n}\n\n.checkout-success {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 12px;\n  padding: 16px 0;\n}\n\n.checkout-success svg {\n  color: var(--ok);\n}\n\n.checkout-success h2 {\n  margin: 0;\n}\n\n.checkout-success p {\n  margin: 0;\n  font-size: 14px;\n  color: var(--ink-secondary);\n}\n\n.checkout-success .rd-btn {\n  min-width: 160px;\n  margin-top: 8px;\n}\n\n.checkout-actions {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.checkout-actions .rd-btn {\n  flex: 1;\n  min-width: 140px;\n}\n\n/* Billing / receipt history (card chrome comes from .rd-card) */\n.billing-history-card {\n  margin-bottom: 24px;\n}\n\n.billing-history-title {\n  margin: 0 0 16px 0;\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--ink);\n}\n\n.billing-history-empty {\n  margin: 0;\n  font-size: 14px;\n  color: var(--ink-secondary);\n}\n\n.billing-history-scroll {\n  overflow-x: auto;\n}\n\n.billing-history-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.billing-history-table th {\n  text-align: left;\n  padding: 10px 12px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--ink-muted);\n  border-bottom: 1px solid var(--line);\n  white-space: nowrap;\n}\n\n.billing-history-table td {\n  padding: 12px;\n  color: var(--ink-secondary);\n  border-bottom: 1px solid var(--line);\n  white-space: nowrap;\n}\n\n.billing-history-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n/* Modal / confirmation */\n.billing-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 16px;\n}\n\n.billing-modal {\n  background: var(--bg-surface);\n  border: 1px solid var(--line);\n  border-radius: var(--r-lg);\n  box-shadow: var(--sh-pop);\n  padding: 24px;\n  width: 100%;\n  max-width: 480px;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.billing-modal h2 {\n  margin: 0 0 8px 0;\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--ink);\n}\n\n.billing-modal p {\n  margin: 0 0 16px 0;\n  font-size: 14px;\n  color: var(--ink-secondary);\n}\n\n.lost-features {\n  list-style: none;\n  padding: 0;\n  margin: 0 0 16px 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.lost-features li {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  font-size: 14px;\n  color: var(--ink-secondary);\n}\n\n.lost-features li svg {\n  flex-shrink: 0;\n  color: var(--err);\n  margin-top: 1px;\n}\n\n.billing-modal-warning {\n  padding: 12px 16px;\n  background: var(--bg-inset);\n  border-radius: var(--r-md);\n  font-size: 13px;\n  color: var(--ink);\n  margin-bottom: 20px;\n}\n\n.billing-modal-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n}\n\n/* Loading */\n.billing-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 48px;\n  gap: 16px;\n  color: var(--ink-secondary);\n}\n\n.billing-spinner {\n  width: 32px;\n  height: 32px;\n  border: 3px solid var(--line);\n  border-top-color: var(--accent);\n  border-radius: 50%;\n  animation: billing-spin 1s linear infinite;\n}\n\n@keyframes billing-spin {\n  to { transform: rotate(360deg); }\n}\n\n/* Tablet+ : two-column plan comparison */\n@media (min-width: 768px) {\n  .plan-compare-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n/* Tablet : meta grid to two columns */\n@media (max-width: 991px) {\n  .current-plan-meta-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n/* Mobile: single column for everything, bottom-sheet style modal */\n@media (max-width: 576px) {\n  .current-plan-meta-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .checkout-pay-meta {\n    grid-template-columns: 1fr;\n  }\n\n  .billing-modal-overlay {\n    align-items: flex-end;\n    padding: 0;\n  }\n\n  .billing-modal {\n    max-width: 100%;\n    border-radius: var(--r-lg) var(--r-lg) 0 0;\n    max-height: 85vh;\n  }\n\n  .checkout-actions .rd-btn {\n    flex: 1 1 100%;\n  }\n\n  .billing-modal-actions .rd-btn {\n    flex: 1 1 100%;\n  }\n\n  /* Billing history: table → stacked label/value cards */\n  .billing-history-scroll {\n    overflow-x: visible;\n  }\n\n  .billing-history-table thead {\n    display: none;\n  }\n\n  .billing-history-table,\n  .billing-history-table tbody,\n  .billing-history-table tr,\n  .billing-history-table td {\n    display: block;\n    width: 100%;\n  }\n\n  .billing-history-table tr {\n    border: 1px solid var(--line);\n    border-radius: var(--r-md);\n    padding: 8px 12px;\n    margin-bottom: 12px;\n  }\n\n  .billing-history-table td {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 12px;\n    padding: 8px 0;\n    border-bottom: 1px solid var(--line);\n    white-space: normal;\n    text-align: right;\n  }\n\n  .billing-history-table tr td:last-child {\n    border-bottom: none;\n  }\n\n  .billing-history-table td::before {\n    content: attr(data-label);\n    font-size: 11px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    color: var(--ink-muted);\n    text-align: left;\n  }\n}\n\n/* ── Pay-on chain picker (plan card) ──────────────────────────────────────── */\n.plan-network { margin: 14px 0 10px; }\n.plan-network__label {\n  display: block; font-size: 11.5px; font-weight: 600;\n  color: var(--t-500, #6c7189); margin-bottom: 6px;\n}\n.plan-network__opts {\n  display: flex; gap: 4px; padding: 3px;\n  background: var(--bg-inset, #eff0f8); border-radius: var(--r-md, 10px);\n}\n.plan-network__opt {\n  flex: 1; padding: 7px 8px; border: none; background: none; cursor: pointer;\n  border-radius: calc(var(--r-md, 10px) - 3px);\n  font-family: inherit; font-size: 12px; font-weight: 600;\n  color: var(--t-500, #6c7189);\n  transition: background 0.15s, color 0.15s;\n}\n.plan-network__opt:hover:not(:disabled) { color: var(--ink, #0e1124); }\n.plan-network__opt.is-active {\n  background: var(--surface, #fff); color: var(--ink, #0e1124);\n  box-shadow: var(--sh-sm, 0 1px 2px rgba(16, 18, 40, 0.06));\n}\n.plan-network__opt:disabled { opacity: 0.55; cursor: default; }\n\n.plan-credit {\n  margin: 0 0 10px; padding: 8px 10px;\n  background: var(--ok-soft, #e6f8f1); color: var(--ok-ink, #0a8f64);\n  border-radius: var(--r-md, 10px);\n  font-size: 12px; font-weight: 600; line-height: 1.4;\n}\n\n/* Premium: when it ends, above the renew controls. Neutral, not \"credit\" green. */\n.plan-active-until {\n  margin-top: 16px;\n  background: var(--bg-inset, #f7f8fc); color: var(--t-600, #4a4f66);\n}\n.plan-cancel-btn { margin-top: 8px; }\n\n/* Test mode: why the upgrade button is disabled. */\n.plan-test-note {\n  display: flex; align-items: flex-start; gap: 6px;\n  margin: 0 0 10px; padding: 8px 10px;\n  background: var(--warn-soft, #fdf3e1); color: var(--warn-ink, #b9760a);\n  border-radius: var(--r-md, 10px);\n  font-size: 12px; font-weight: 600; line-height: 1.4;\n}\n.plan-test-note svg { flex: none; margin-top: 1px; }\n\n/* A part-paid row in the history has to explain itself, or it reads as\n   \"we took your money and gave you nothing\". */\n.billing-part-paid {\n  display: block; margin-top: 2px;\n  font-size: 11px; font-weight: 600; color: var(--warn-ink, #b9760a);\n}\n\n/* ═══════════════════════════════════════════════════════════════════════════\n   Billing, 2026 layout: gradient plan hero, KPI row, history beside the offer.\n   ═══════════════════════════════════════════════════════════════════════════ */\n\n/* ── Hero ─────────────────────────────────────────────────────────────────── */\n.bill-hero {\n  padding: 24px 28px; margin-bottom: var(--space-5, 20px);\n  border-radius: var(--r-xl, 20px);\n  /* The mockup's violet, deepening across the band. Measured against white:\n     6.3:1 at the start, 9.3:1 at the end, so every stop clears the 4.5:1 body\n     minimum -- including the 68%-alpha sub-labels, which flatten to 4.7:1. */\n  background: var(--grad-balance);\n  color: #fff;\n  position: relative; overflow: hidden;\n}\n/* The soft bloom in the mockup's top-right. Decorative only. */\n.bill-hero::after {\n  content: ''; position: absolute; right: -60px; top: -70px;\n  width: 260px; height: 260px; border-radius: 50%;\n  background: rgba(255, 255, 255, 0.07); pointer-events: none;\n}\n\n/* Band 1: who you are and the one action that changes it. */\n.bill-hero__top {\n  position: relative; z-index: 1;\n  display: flex; align-items: flex-start; justify-content: space-between;\n  gap: 24px; flex-wrap: wrap;\n}\n\n.bill-hero__plan { display: flex; align-items: flex-start; gap: 14px; min-width: 240px; }\n.bill-hero__crest {\n  flex: none; width: 46px; height: 46px; display: grid; place-items: center;\n  border-radius: 14px; background: rgba(255, 255, 255, 0.16);\n}\n.bill-hero__eyebrow {\n  display: block; font-size: 12px; font-weight: 600;\n  color: rgba(255, 255, 255, 0.78); margin-bottom: 2px;\n}\n.bill-hero__name { display: flex; align-items: center; gap: 10px; }\n.bill-hero__name h2 {\n  margin: 0; font-size: 26px; line-height: 1.1; text-transform: capitalize; color: #fff;\n}\n.bill-hero__status {\n  font-size: 11.5px; font-weight: 700; text-transform: capitalize;\n  padding: 3px 10px; border-radius: 999px;\n  background: rgba(255, 255, 255, 0.22); color: #fff;\n}\n.bill-hero__blurb {\n  margin: 6px 0 0; font-size: 13px; line-height: 1.45;\n  color: rgba(255, 255, 255, 0.8); max-width: 46ch;\n}\n\n.bill-hero__cta {\n  flex: none; display: inline-flex; align-items: center; gap: 8px;\n  padding: 11px 20px; border: none; border-radius: 999px; cursor: pointer;\n  background: #fff; color: #3e31ae;\n  font-family: inherit; font-size: 13.5px; font-weight: 700;\n  transition: transform 0.14s ease, box-shadow 0.14s ease;\n}\n.bill-hero__cta:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 18px rgba(16, 18, 40, 0.22);\n}\n.bill-hero__cta:disabled { opacity: 0.65; cursor: default; }\n\n/* Band 2: the figures, on an even grid.\n   A grid rather than a flex row so the four columns are the same width and the\n   labels line up, instead of each one taking whatever space was left. */\n.bill-hero__stats {\n  position: relative; z-index: 1;\n  display: grid; grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 1px; margin-top: 22px; padding-top: 20px;\n  border-top: 1px solid rgba(255, 255, 255, 0.16);\n}\n.bill-hero__stat { padding: 0 18px; min-width: 0; }\n.bill-hero__stat + .bill-hero__stat { box-shadow: inset 1px 0 0 rgba(255, 255, 255, 0.14); }\n.bill-hero__stat:first-child { padding-left: 0; }\n.bill-hero__stat:last-child { padding-right: 0; }\n\n.bill-hero__stat-icon {\n  width: 28px; height: 28px; display: grid; place-items: center;\n  border-radius: 50%; border: 1px solid rgba(255, 255, 255, 0.3);\n  margin-bottom: 9px;\n}\n.bill-hero__stat-label {\n  display: block; font-size: 12px; font-weight: 600;\n  color: rgba(255, 255, 255, 0.82); margin-bottom: 3px;\n  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;\n}\n.bill-hero__stat strong {\n  display: block; font-size: 22px; font-weight: 700; line-height: 1.15;\n  font-variant-numeric: tabular-nums; color: #fff;\n}\n.bill-hero__stat-sub {\n  display: block; margin-top: 3px;\n  font-size: 11.5px; color: rgba(255, 255, 255, 0.68);\n}\n\n/* ── History + offer ──────────────────────────────────────────────────────── */\n/* Both columns share the row height, so the two cards end level. With\n   align-items: start the history card sized to its own rows -- four of them in\n   a three-month window -- and finished 150px above the offer card beside it.\n   Stretching is safe because the slack has somewhere to go: the table area\n   grows and the pager is pinned to the bottom. */\n.bill-grid {\n  display: grid; grid-template-columns: minmax(0, 1fr) 360px;\n  gap: var(--space-5, 20px); align-items: stretch;\n}\n\n.bill-history { overflow: hidden; display: flex; flex-direction: column; }\n/* Takes the leftover height rather than letting it pool under the card. */\n.bill-history__scroll { flex: 1; }\n.bill-history .pager {\n  margin-top: auto;\n  padding: 12px 20px;\n  border-top: 1px solid var(--line, #eaebf3);\n}\n\n.bill-side { display: flex; flex-direction: column; }\n/* .bill-side > * { flex: 1; } */\n.bill-history__head {\n  display: flex; align-items: flex-start; justify-content: space-between;\n  gap: 16px; flex-wrap: wrap;\n  padding: 18px 20px; border-bottom: 1px solid var(--line, #eaebf3);\n}\n.bill-history__head h2 { margin: 0; font-size: 17px; }\n.bill-history__head p { margin: 3px 0 0; font-size: 12.5px; color: var(--t-500, #6c7189); }\n\n.bill-range {\n  display: inline-flex; align-items: center; gap: 7px;\n  padding: 7px 11px; border: 1px solid var(--line, #eaebf3);\n  border-radius: var(--r-md, 10px); background: var(--surface, #fff);\n  color: var(--t-500, #6c7189);\n}\n.bill-range select {\n  border: none; background: none; outline: none; cursor: pointer;\n  font-family: inherit; font-size: 12.5px; font-weight: 600;\n  color: var(--ink, #0e1124);\n}\n\n.bill-history__scroll { overflow-x: auto; flex: 1; }\n.bill-table { width: 100%; border-collapse: collapse; }\n.bill-table thead th {\n  text-align: left; padding: 11px 20px;\n  font-size: 11px; font-weight: 700; letter-spacing: 0.4px; text-transform: uppercase;\n  color: var(--t-500, #6c7189); background: var(--bg-inset, #f7f8fc);\n  border-bottom: 1px solid var(--line, #eaebf3);\n  white-space: nowrap;\n}\n.bill-table tbody td {\n  padding: 13px 20px; font-size: 13px; vertical-align: middle;\n  color: var(--ink, #0e1124);\n  border-bottom: 1px solid var(--line, #eaebf3);\n}\n.bill-table tbody tr:last-child td { border-bottom: none; }\n.bill-table tbody tr { transition: background 0.14s ease; }\n.bill-table tbody tr:hover { background: rgba(109, 93, 246, 0.04); }\n.bill-num { text-align: right; }\n.bill-plan { text-transform: capitalize; }\n\n.bill-token { display: inline-flex; align-items: center; gap: 8px; font-weight: 600; white-space: nowrap; }\n\n.bill-history__empty {\n  flex: 1; display: flex; flex-direction: column;\n  align-items: center; justify-content: center;\n  text-align: center; padding: 46px 20px;\n}\n.bill-history__empty-icon {\n  display: inline-grid; place-items: center; width: 48px; height: 48px;\n  border-radius: 14px; margin-bottom: 12px;\n  background: var(--brand-100, #ece9ff); color: var(--brand-700, #5847d6);\n}\n.bill-history__empty h3 { margin: 0 0 5px; font-size: 15px; }\n.bill-history__empty p { margin: 0; font-size: 13px; color: var(--t-500, #6c7189); }\n\n/* ── Offer card (right rail) ──────────────────────────────────────────────── */\n/* The card fills its column, so the slack goes between the feature list and\n   the action rather than below everything -- the same reason the pager is\n   pinned in the card beside it. */\n.bill-offer { display: flex; flex-direction: column; }\n.bill-offer__features { margin-bottom: auto !important; }\n.bill-offer .plan-network { margin-top: 18px; }\n\n.bill-offer h3 { margin: 0 0 4px; font-size: 16px; }\n.bill-offer__blurb { margin: 0; font-size: 13px; color: var(--t-500, #6c7189); line-height: 1.5; }\n.bill-offer__price {\n  font-size: 30px; font-weight: 700; margin: 2px 0 14px;\n  color: var(--ink, #0e1124); font-variant-numeric: tabular-nums;\n}\n.bill-offer__price small { font-size: 13px; font-weight: 600; color: var(--t-500, #6c7189); }\n.bill-offer__features { list-style: none; margin: 0 0 16px; padding: 0; display: grid; gap: 8px; }\n.bill-offer__features li {\n  display: flex; align-items: flex-start; gap: 8px;\n  font-size: 12.5px; line-height: 1.4; color: var(--t-600, #4a4f66);\n}\n.bill-offer__features svg { flex: none; margin-top: 1px; color: var(--ok, #0fb981); }\n\n/* ── Narrow ───────────────────────────────────────────────────────────────── */\n@media (max-width: 1180px) {\n  .bill-grid { grid-template-columns: minmax(0, 1fr); }\n  .bill-side { max-width: 520px; }\n  /* Stacked, there is no neighbour to match, so nothing should be stretched. */\n  .bill-side > * { flex: none; }\n}\n@media (max-width: 1040px) {\n  .bill-hero__stats { grid-template-columns: repeat(2, minmax(0, 1fr)); row-gap: 20px; }\n  .bill-hero__stat:nth-child(odd) { padding-left: 0; }\n  .bill-hero__stat:nth-child(3) { box-shadow: none; }\n}\n@media (max-width: 900px) {\n  .bill-hero { gap: 20px; padding: 22px; }\n  .bill-hero__cta { width: 100%; justify-content: center; }\n}\n@media (max-width: 560px) {\n  .bill-hero__stats { grid-template-columns: minmax(0, 1fr); row-gap: 18px; }\n  .bill-hero__stat { padding: 0; box-shadow: none !important; }\n  .bill-hero__cta { width: 100%; justify-content: center; }\n  .bill-table thead th, .bill-table tbody td { padding-left: 14px; padding-right: 14px; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .bill-hero__cta { transition: none; }\n  .bill-hero__cta:hover:not(:disabled) { transform: none; }\n}\n\n/* A charge that never confirmed earned no receipt. Saying so beats a dash. */\n.bill-no-receipt {\n  font-family: var(--font-sans, inherit);\n  font-size: 12px; color: var(--t-400, #9aa0b6); font-style: italic;\n}\n\n/* Placeholder while the real price is in flight. Dimmed so it reads as\n   \"not yet\" rather than as a figure. */\n.bill-offer__price-wait { color: var(--t-400, #9aa0b6); }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
